import { FC, MouseEvent as ReactMouseEvent } from 'react';

interface IProps {
  text: string;
  index: number;
  isActive: boolean;

  onClick(e: ReactMouseEvent, index: number): void;
}

const TabItem: FC<IProps> = ({ text, index, isActive, onClick }) => {
  return (
    <li className={isActive ? 'active' : ''}>
      <a
        className="btn-item"
        onClick={(e) => onClick(e, index)}
      >
        {text}
      </a>
    </li>
  );
};

export default TabItem;
